import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=13ada107&scoped=true"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"
import style0 from "./Example.vue?vue&type=style&index=0&id=13ada107&prod&lang=scss&scoped=true"
import style1 from "./Example.vue?vue&type=style&index=1&id=13ada107&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ada107",
  null
  
)

export default component.exports